import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const FloatingMenu = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-8 right-8 flex flex-col items-end gap-4 z-50">
      {/* Botones emergentes */}
      {open && (
        <div className="flex flex-col items-end gap-3 animate-fade-in">
          <a
            href="#contacto"
            className="bg-[var(--color-dark)] text-white px-5 py-3 rounded-full shadow-md hover:bg-[var(--color-accent)] transition-all font-medium"
          >
            📩 Formulario
          </a>
          <a
            href="https://wa.me/5493585727260"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[var(--color-dark)] text-white px-5 py-3 rounded-full shadow-md hover:bg-[var(--color-accent)] transition-all font-medium"
          >
            💬 WhatsApp
          </a>
        </div>
      )}

      {/* Botón principal */}
      <button
        onClick={() => setOpen(!open)}
        className="bg-[var(--color-accent)] text-white p-6 rounded-full shadow-xl hover:scale-110 hover:shadow-2xl transition-transform"
        aria-label="Abrir menú de contacto"
      >
        {open ? <X size={32} /> : <MessageCircle size={32} />}
      </button>
    </div>
  );
};

export default FloatingMenu;
